import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class HomeRank {
  criteria: string[];

  @Expose({ name: 'current_rank' })
  currentRank?: number;

  @Expose({ name: 'rank_achievements' })
  @Type(() => HomeAchievedRank)
  achievedRanks: HomeAchievedRank[];

  @Expose({ name: 'higher_ranks' })
  @Type(() => HomeNextRank)
  higherRanks: HomeNextRank[];

  @Expose({ name: 'criteria_achieved' })
  @Type(() => RankCriteriaAchieved)
  criteriaAchieved: RankCriteriaAchieved;

  constructor(
    criteria: string[],
    currentRank: number | undefined,
    achievedRanks: HomeAchievedRank[],
    higherRanks: HomeNextRank[],
    criteriaAchieved: RankCriteriaAchieved
  ) {
    this.criteria = criteria;
    this.currentRank = currentRank;
    this.achievedRanks = achievedRanks;
    this.higherRanks = higherRanks;
    this.criteriaAchieved = criteriaAchieved;
  }

  static fromJson(json: Record<string, any>): HomeRank {
    return plainToInstance(HomeRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class HomeAchievedRank {
  id: number;

  name: string;

  bonus: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  @Expose({ name: 'referral_count' })
  referralCount?: number;

  pv?: string;

  tv?: string;

  constructor(
    id: number,
    name: string,
    bonus: string,
    dateCreated: Date,
    referralCount: number | undefined,
    pv: string | undefined,
    tv: string | undefined
  ) {
    this.id = id;
    this.name = name;
    this.bonus = bonus;
    this.dateCreated = dateCreated;
    this.referralCount = referralCount;
    this.pv = pv;
    this.tv = tv;
  }

  static fromJson(json: Record<string, any>): HomeAchievedRank {
    return plainToInstance(HomeAchievedRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class HomeNextRank {
  id: number;

  name: string;

  bonus: string;

  @Expose({ name: 'referral_count' })
  referralCount?: number;

  pv?: string;

  tv?: string;

  purchase?: string;

  constructor(
    id: number,
    name: string,
    bonus: string,
    referralCount: number | undefined,
    pv: string | undefined,
    tv: string | undefined,
    purchase: string | undefined
  ) {
    this.id = id;
    this.name = name;
    this.bonus = bonus;
    this.referralCount = referralCount;
    this.pv = pv;
    this.tv = tv;
    this.purchase = purchase;
  }

  static fromJson(json: Record<string, any>): HomeNextRank {
    return plainToInstance(HomeNextRank, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class RankCriteriaAchieved {
  @Expose({ name: 'referral_count' })
  referralCount?: number;

  pv?: string;

  tv?: string;

  purchase?: string;

  constructor(
    referralCount: number | undefined,
    pv: string | undefined,
    tv: string | undefined,
    purchase: string | undefined
  ) {
    this.referralCount = referralCount;
    this.pv = pv;
    this.tv = tv;
    this.purchase = purchase;
  }

  static fromJson(json: Record<string, any>): RankCriteriaAchieved {
    return plainToInstance(RankCriteriaAchieved, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
